import _u from './util';

let _v = {
	'isTouchDevice' : false,
	'slryApiDom': 'k8s.',
	'pageNumber': 1,
	'pageSize': 10,
	'processing': true,
	'cmeTimer': null,
	'cmePopCancelled': false,
	'noMoreRecEngineFeedContent': false,
	'siteID': 303779,
	'lfNetworkName': 'medscape-1',
	'firstPageFeedData': [],
	'topArticleId': null,
	'topContId': null,
	'feedAndTopLoaded': false,
	'cmeGliderInst': null,
	'cmeShareElem': null,
	'cmeGliderSwiping': false,
	'initialLoadEvent': 'cmeGliderLoaded',
	'cmeCarouselPos': 3,
	'isFYE': null,
	'contentFeedURL': null
};

// Set API Domain
_v.contentFeedURL = 'https://www.' + _u.getDomain() + 'medscape.com/rec-engine/api/v1/content_feed?';
if (_u.getDomain().indexOf('dev01') != '-1') {
	_v.slryApiDom = 'k8s.devint.';
} else if (_u.getDomain().indexOf('qa01') != '-1') {
	_v.slryApiDom = 'k8s.qa.';
} else if (_u.getDomain().indexOf('staging') != '-1') {
	_v.slryApiDom = 'k8s.staging.';
	_v.siteID = 324818;
	_v.lfNetworkName = 'medscape';
} else {
	_v.slryApiDom = 'k8s.';
	_v.siteID = 324818;
	_v.lfNetworkName = 'medscape';
}

if (typeof window.ontouchstart !== 'undefined') {
	_v.isTouchDevice = true;
}

if (typeof window.hideCmeGlider !== 'undefined' &&  window.hideCmeGlider) {
	_v.initialLoadEvent = 'feedAndTopLoaded';
}

if (typeof window.cmeCarouselPos == "number") {
	_v.cmeCarouselPos = window.cmeCarouselPos;
}

export default _v;